import React from 'react';

const InputHidden = (props) => {
    const { field = {} } = props;

    return (
        <>
            <input
                id={field.name}
                name={field.canonicalPath ? field.canonicalPath : field.name}
                value={field.value || ''}
                type={field.type}
                autoComplete="off"
            />
        </>
    );
};
export default InputHidden;
